import React from 'react'

import { formatMillisecondsToTime } from 'utils/time'

import ExceptionTailPill from '../ExceptionTailPill'

// Delay cards surface their timer (HH:MM:SS) sourced from exception.delayTime.
type DelayTailProps = {
  delayTime?: number | null
}

const DelayTail: React.FC<DelayTailProps> = ({ delayTime }) => {
  if (!delayTime || delayTime <= 0) return null
  return <ExceptionTailPill>{formatMillisecondsToTime(delayTime)}</ExceptionTailPill>
}

export default DelayTail
